import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DangerousGoodsClassifier from './components/DangerousGoodsClassifier';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <div className="App">
        <ProtectedRoute>
          <DangerousGoodsClassifier />
        </ProtectedRoute>
      </div>
    </AuthProvider>
  );
};

export default App;